import { render, staticRenderFns } from "./VacunaTipoMujer.vue?vue&type=template&id=d633991a&scoped=true"
import script from "./VacunaTipoMujer.vue?vue&type=script&lang=js"
export * from "./VacunaTipoMujer.vue?vue&type=script&lang=js"
import style0 from "./VacunaTipoMujer.vue?vue&type=style&index=0&id=d633991a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d633991a",
  null
  
)

export default component.exports